export const GET_CONTACT_US_REQUEST = "GET_CONTACT_US_REQUEST";
export const GET_CONTACT_US_SUCCESS = "GET_CONTACT_US_SUCCESS";
export const GET_CONTACT_US_FAILURE = "GET_CONTACT_US_FAILURE";

export const UPDATE_ANSWER_CONTACT_US_REQUEST =
  "UPDATE_ANSWER_CONTACT_US_REQUEST";
export const UPDATE_ANSWER_CONTACT_US_SUCCESS =
  "UPDATE_ANSWER_CONTACT_US_SUCCESS";
export const UPDATE_ANSWER_CONTACT_US_FAILURE = "GET_CONTACT_US_FAILURE";
